import { useState } from 'react';

const DELAY_MS = 300;
let startedAt: number | null = null;

/** Ends a loading: the next skeleton waits its delay again. */
export function settleSkeletons() {
  startedAt = null;
}

/** How long a skeleton that appears `now` still waits; the delay counts from the first skeleton of a loading. */
export function skeletonDelayLeft(now: number): number {
  startedAt ??= now;
  return Math.max(0, DELAY_MS - (now - startedAt));
}

/**
 * A skeleton waits a moment and fades in, so a fast load shows none. The ones that follow it
 * in the same loading (route, page, pane, rows) appear at once: they would only blink out and in.
 */
export function useSkeletonFade(): { className: string; style?: object } {
  return useState(() => {
    const left = skeletonDelayLeft(Date.now());
    return left === 0
      ? { className: '' }
      : {
          className:
            'animate-in fade-in-0 duration-300 [animation-fill-mode:backwards] motion-reduce:animate-none',
          style: { animationDelay: `${left}ms` }
        };
  })[0];
}
